<div class="primary-sidebar" [class.disabled-sidebar]="isSidebarDisabled" (mouseleave)="onMouseLeave()">
  <!-- Top Logo Container -->
  <!-- <div class="logo-container">
    <div class="logo-circle">
      <img src="/img/hropal_new.png" alt="Logo" class="sidebar-logo-img" />
    </div>
  </div> -->

  <div class="sidebar-top-action-container">
    @if (isSubSidebarCollapsed) {
    <i class="hgi hgi-stroke hgi-rounded hgi-arrow-right-double sidebar-top-bg-logo" (click)="openSubSidebar()"
      style="cursor: pointer"></i>
    }
  </div>
  <!-- Parent Menu Navigation -->
  <div class="nav-scroll">
    <ul class="nav-list">
      <li *ngFor="let item of parentMenulist" class="nav-item">

        <a class="nav-link" [class.active-link]="item.id === activeParentId" (click)="selectParentMenu(item)"
          (mouseenter)="onItemHover(item, $event)">
          <div class="icon-wrapper">
            <i [class]="item.icon" alt="" class="sidebar-icon"></i>
          </div>
          <span class="menu-name">{{ item.name }}</span>
        </a>
      </li>
    </ul>
  </div>
</div>